var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQueueProps(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.7,24.86a1.27,1.27,0,0,1-1-.3c-.16-.21,0-.61,0-.85L2,23.15a12.08,12.08,0,0,1,1.55-2.39,1.29,1.29,0,0,1,1.54-.34,4.1,4.1,0,0,1,.72.6,2.39,2.39,0,0,0,1.52.52h.49A2.46,2.46,0,0,0,9.36,21a3.36,3.36,0,0,1,.7-.6,1.2,1.2,0,0,1,1.41.24,10.5,10.5,0,0,1,1.46,2.48l.27.55a1,1,0,0,1,.08.86,1,1,0,0,1-.94.3Z",
    style: {
      fill: "#7e7e7e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1,16.42a3.51,3.51,0,0,0,3.3-3.7v-.09a3.4,3.4,0,0,0-3.3-3.49H16a3.41,3.41,0,0,0-3.25,3.58v0A3.53,3.53,0,0,0,16.1,16.42Z",
    style: {
      fill: "#7e7e7e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.64,19.84a3.53,3.53,0,0,0,3.29-3.68v-.09a3.39,3.39,0,0,0-3.27-3.53H7.52a3.39,3.39,0,0,0-3.2,3.56v.07h0A3.55,3.55,0,0,0,7.64,19.84Z",
    style: {
      fill: "#7e7e7e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.48,13.14a3.55,3.55,0,0,0,3.31-3.71V9.36a3.4,3.4,0,0,0-3.31-3.49h-.06a3.38,3.38,0,0,0-3.23,3.52h0a3.52,3.52,0,0,0,3.23,3.75Z",
    style: {
      fill: "#7e7e7e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1,17.2A1.2,1.2,0,0,0,18.72,17a3.76,3.76,0,0,0-.72.6,2.42,2.42,0,0,1-1.57.52H16a2.39,2.39,0,0,1-1.58-.52,4.3,4.3,0,0,0-.73-.61,1.28,1.28,0,0,0-1.53.25,11.63,11.63,0,0,0-1.62,2.42l-.11.21a1.63,1.63,0,0,1,1.58.47,12,12,0,0,1,.78,1.09h5.62A6,6,0,0,1,20.1,17.2Z",
    style: {
      fill: "#7e7e7e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.34,16.83a6.16,6.16,0,0,1,4-1.51h0a6.18,6.18,0,0,1,5.17,2.85,1,1,0,0,0,.78-.31,1.06,1.06,0,0,0-.07-.87l-.29-.55a9.64,9.64,0,0,0-1.51-2.5A1.21,1.21,0,0,0,27,13.69a3.75,3.75,0,0,0-.71.61,2.42,2.42,0,0,1-1.55.5h-.5a2.35,2.35,0,0,1-1.58-.55,3.76,3.76,0,0,0-.72-.6,1.26,1.26,0,0,0-1.55.24,11.35,11.35,0,0,0-1.57,2.41v.07A1.65,1.65,0,0,1,20.34,16.83Z",
    style: {
      fill: "#7e7e7e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.07,22.17V20.49H27.89a3.66,3.66,0,0,0-.42-1l.86-.85-1.19-1.18-.84.84a3.59,3.59,0,0,0-1-.39V16.72H23.59v1.19a3.4,3.4,0,0,0-1,.39l-.87-.84-1.18,1.18.86.85a3.64,3.64,0,0,0-.41,1H19.83v1.68H21a3.39,3.39,0,0,0,.47,1l-.86.85,1.18,1.18.85-.84a4.31,4.31,0,0,0,1,.41V26h1.68V24.77a3.48,3.48,0,0,0,1-.42l.86.85L28.36,24l-.93-.85a3.58,3.58,0,0,0,.41-.94ZM24.42,23a1.68,1.68,0,1,1,1.69-1.68h0A1.69,1.69,0,0,1,24.45,23Z",
    style: {
      fill: "#636363"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQueueProps);
export default __webpack_public_path__ + "static/media/queue-props.0be7077d.svg";
export { ForwardRef as ReactComponent };